export default {
  loginShow: false,
  signUpShow: false,
  agreementShow: false,
  scoreShow: false,
  markShow: false,
  ctalogueShow: false,
  matchInfo: '',
  ctalogueInfo: {},
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || '',
  signPath: '',
  workDatas: {},

  tabIndex: localStorage.getItem('tabIndex'),//判断
  matchTitle: '',
  configs:JSON.parse(localStorage.getItem('configs')) || {},
}



// WEBPACK FOOTER //
// ./src/store/state.js